import { SidebarTab } from 'components';
import ExamIcon from 'components/assets/svg/sidebar/exams.svg';
import AcIcon from 'components/assets/svg/sidebar/cok.svg';

const sidebarTabs: SidebarTab[] = [
    /*{
        name: 'Аккредитации',
        icon: ExamIcon,
        state: 'exams',
        list: [
            {
                name: 'Запросы на проведение',
                path: '/conduct-requests',
                routes: ['/exam/*?from=conduct-requests'],
            },
            {
                name: 'Список аккредитаций',
                path: '/exam-list',
                routes: ['/exam/*?from=exam-list'],
            },
        ],
    },*/
    {
        name: 'Управление АЦ',
        icon: AcIcon,
        state: 'asc',
        list: [
            {
                name: 'Администраторы АЦ',
                path: '/users',
            },
            {
                name: 'Специальности АЦ',
                path: '/qualifications',
                routes: ['/qualifications/*'],
            },
            {
                name: 'Информация по АЦ',
                path: '/details',
            },
        ],
    },
];

export default sidebarTabs;
